import * as Yup from 'yup';

import { StepSourceSpecificationForm } from './step-source-specification-types';

export const stepSourceSpecificationSchema = () =>
  Yup.object<StepSourceSpecificationForm>().shape({
    sourceId: Yup.string().required('Povinné pole'),
    name: Yup.string().required('Povinné pole'),
    sourceCategory: Yup.object().required('Povinné pole'),
    determinationMethod: Yup.object().required('Povinné pole'),
  });
